import { render, staticRenderFns } from "./People.vue?vue&type=template&id=37d14e74&"
import script from "./People.vue?vue&type=script&lang=js&"
export * from "./People.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d14e74')) {
      api.createRecord('37d14e74', component.options)
    } else {
      api.reload('37d14e74', component.options)
    }
    module.hot.accept("./People.vue?vue&type=template&id=37d14e74&", function () {
      api.rerender('37d14e74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/people/People.vue"
export default component.exports